<template>
  <div>
    <div class="hidden-lg-and-up">
      <el-card v-for="item in selectedProductItemsLeft" :key="item.id" shadow="never" style="margin-top:10px;">
        <span class="fs-14 secondary-text">{{$t('products.shortReleaseDateField')}} {{moment(item.availabilityDate)}}</span><br>
        <span class="fs-14 secondary-text">{{$t('products.referenceNumberField')}} {{item.reference}}</span><br>
        <span class="fs-14 secondary-text">{{$t('products.endDelayField')}} {{momentAdd(item.availabilityDate,inventoryProductDelay)}}</span><br>
        <span class="fs-14 secondary-text">{{$t('products.daysElpasedSinceArrivalField')}} <span v-if="item.quantity.onHand > 0">{{item.nbDays}}</span><span v-else> -- </span></span><br>
        <span class="fs-14 secondary-text">{{$t('products.initialQuantityField')}} {{item.qty}}</span><br>
        <span class="fs-14 secondary-text">{{$t('products.inStockQuantityField')}} {{item.quantity.onHand}}</span>
      </el-card>
    </div>
    <el-skeleton :count="1" animated :loading="loadingSelectedProductItems">
      <template slot="template">
        <tableSkeleton :rows="6" :columnLabel="[{ label: '', width:50, sortable:false}, { label: '', width:30, sortable:false},{ label: $t('common.date'), width:100, sortable:false}, {label: $t('products.referenceNumber'), sortable:false}, {label: $t('products.endDelay'), width:100,sortable:false}, { label: $t('products.shortReleaseDate'),width: 100, sortable:false}, {label: $t('products.daysElpasedSinceArrival'), width: 100, sortable:false},]"></tableSkeleton>
      </template>
      <template>
        <el-table
           :data="selectedProductItemsLeft"
           stripe
           style="width: 100%"
           class="hidden-md-and-down">
           <el-table-column type="expand">
            <template slot-scope="props">
              <el-row :gutter="20">
                <el-col :xs="8" :sm="24" :md="24" :lg="12" :xl="12">
                  <h4>{{ $t('products.batch') }} <span v-if="props.row.reference != null && props.row.reference !== ''">- {{props.row.reference}}</span></h4>
                  <el-divider />
                  <el-row v-if="inventory.code !== 'IP' && inventory.code !== 'PI'">
                    <el-col>
                      <span class="fs-14  secondary-text">
                        {{$t('products.costPriceField')}}
                      </span>
                      <span class="fs-14 secondary-text">
                        {{$n(props.row.purchaseUnitPrice,'currency')}}
                      </span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <span class="fs-14  secondary-text" v-if="inventory.code === 'IP' || inventory.code === 'PI'">
                        {{$t('products.priceWithLicenceField')}}
                      </span>
                      <span class="fs-14  secondary-text" v-else>
                        {{$t('products.priceField')}}
                      </span>
                      <span class="fs-14 secondary-text">
                        {{$n(props.row.price,'currency')}}
                      </span>
                    </el-col>
                  </el-row>
                  <el-row v-if="inventory.code === 'IP' || inventory.code === 'PI'">
                    <el-col>
                      <span class="fs-14  secondary-text">{{$t('products.priceWithoutLicenceField')}} </span>
                        <span class="fs-14 secondary-text">{{$n(props.row.priceTaxIn,'currency')}}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <span class="fs-14 secondary-text">{{$t('products.shortReleaseDateField')}} </span>
                      <span class="fs-14 secondary-text">{{moment(props.row.availabilityDate)}}</span>
                    </el-col>
                  </el-row>
                  <el-row v-if="inventoryId && (inventory.code ==='IP' || inventory.code ==='PI')">
                    <el-col>
                      <span class="fs-14 secondary-text">{{$t('products.endDelayField')}} </span>
                      <span class="fs-14 secondary-text">{{momentAdd(props.row.availabilityDate, inventoryProductDelay)}}</span>
                    </el-col>

                  </el-row>
                  <el-row>
                    <el-col>
                      <span class="fs-14 secondary-text">{{$t('products.initialQuantityField')}} </span>
                      <span class="fs-14 secondary-text">{{props.row.quantity.total}}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <span class="fs-14 secondary-text">{{$t('products.inStockQuantityField')}} </span>
                      <span class="fs-14 secondary-text">{{props.row.quantity.onHand}}</span>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col  :xs="8" :sm="24" :md="24" :lg="12" :xl="12">
                  <h4>{{$t('products.purchaseOrder')}}</h4>
                  <el-divider />
                  <el-row>
                    <el-col>
                      <span class="fs-14 secondary-text">{{$t('products.purchaseOrderField')}} </span>
                      <PortausLink v-if="props.row.purchaseOrder!=null && props.row.purchaseOrder.status.code!='IMPORTED'" :path="'/inventories/' + inventoryId+'/purchase-orders/'" :id="props.row.purchaseOrder.id" :label="props.row.purchaseOrder.poNumber"></PortausLink>
                      <span v-else>{{ $t('common.notAvailable') }}</span>
                    </el-col>
                  </el-row>
                  <el-row v-if="props.row.purchaseOrder != null">
                    <el-col>
                      <span class="fs-14  secondary-text">{{ $t('products.dateField') }} </span>
                      <span class="fs-14 secondary-text" v-if="props.row.purchaseOrder.date != null">
                        {{moment(props.row.purchaseOrder.date)}}
                      </span>
                      <span v-else class="fs-14 secondary-text">{{ $t('common.notAvailable') }}</span>
                    </el-col>
                  </el-row>
                  <el-row v-if="props.row.purchaseOrder != null">
                    <el-col>
                      <span class="fs-14  secondary-text">{{$t('purchase_orders.Reference')}} </span>
                      <span class="fs-14 secondary-text">
                        {{props.row.purchaseOrder.reference}}
                      </span>
                    </el-col>
                  </el-row>
                  <el-row v-if="props.row.purchaseOrder != null">
                    <el-col>
                      <span class="fs-14  secondary-text">{{$t('purchase_orders.Reference2')}}</span>
                      <span class="fs-14 secondary-text">
                        {{props.row.purchaseOrder.reference2}}
                      </span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col>
                      <span class="fs-14  secondary-text">{{$t('purchase_orders.descriptionField')}}</span>
                      <span class="fs-14 secondary-text" v-if="props.row.purchaseOrder != null && props.row.purchaseOrder.lines != null && props.row.purchaseOrder.lines.length > 0">
                        {{props.row.purchaseOrder.lines[0].purchaseDescription}}
                      </span>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
           <el-table-column
           width="30">
            <template slot-scope="scope">
              <status-indicator v-if="scope.row.quantity.onHand > 0" :negative="isNegative(scope.row.nbDays,scope.row.quantity.onHand)" :intermediary="isIntermediary(scope.row.nbDays,scope.row.quantity.onHand)" :positive="isPositive(scope.row.nbDays,scope.row.quantity.onHand)" pulse/>
            </template>
           </el-table-column>
           <el-table-column
             show-overflow-tooltip
             width="100"
             :label="$t('common.date')">
             <template slot-scope="scope">
               <span>{{moment(scope.row.availabilityDate)}}</span>
             </template>
           </el-table-column>
           <el-table-column
             show-overflow-tooltip
             :label="$t('products.referenceNumber')">
            <template slot-scope="scope">
              <span>{{scope.row.reference}}</span>
            </template>
           </el-table-column>
           <el-table-column
             show-overflow-tooltip
             :label="$t('products.shortAdditionnalInformation')">
            <template slot-scope="scope">
              <span>{{getVintage(scope.row)}}</span>
              <el-link
                v-if="scope.row.productItem != null"
                :underline="false"
                @click="showTechnicalSheet(scope.row.productItem.id)">
                <i class="mdi mdi-book-open ml-5" />
              </el-link>
            </template>
           </el-table-column>
           <el-table-column v-if="inventoryId && showEndOfDelay"
              show-overflow-tooltip
              width="100"
             :label="$t('products.endDelay')">
             <template slot-scope="scope">
               <span>{{momentAdd(scope.row.availabilityDate, inventoryProductDelay)}}</span>
             </template>
           </el-table-column>
           <el-table-column v-if="inventoryId"
             :label="$t('products.shortAvailableQty')"
             width="100"
             align="center">
             <template slot-scope="scope">
               <span>{{scope.row.quantity.onHand}}</span>
             </template>
           </el-table-column>
           <el-table-column v-if="inventoryId && showEndOfDelay"
             :label="$t('products.shortDaysElpasedSinceArrival')"
             width="100"
             align="center">
             <template slot-scope="scope">
               <span v-if="scope.row.quantity.onHand > 0">{{scope.row.nbDays}}</span>
               <span v-else> -- </span>
             </template>
           </el-table-column>
           <el-table-column width="40" align="center" >
             <template slot-scope="scope">
               <el-button type="text" @click="$emit('edit', scope.row)"><i class="el-icon-edit"></i></el-button>
             </template>
           </el-table-column>
       </el-table>
      </template>
    </el-skeleton>
    <TechnicalSheetDrawer
      :visible="technicalSheetDrawerVisible"
      :id="technicalSheetId"
      @close="closeTechnicalSheet"/>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import ProductUtil from '@/utils/product-util'
import PortausLink from '@/components/portaus-link'
import tableSkeleton from '@/components/skeleton/table-skeleton'
import TechnicalSheetDrawer from './technical-sheet-drawer'

export default {
  name: 'AvailableBatch',
	props: {
    selectedProductItemsLeft : {
      type : Array,
      default : ()=> {return []}
    },
    edit : {type:Boolean, default : false},
    priceValue : null,
    inventoryProductDelayLimit : Number,
    inventoryProductDelay : Number,
    inventoryId : Number,
    showEndDelay: {
      type: Boolean,
      default: true
    }
	},
  data() {
    return {
      technicalSheetDrawerVisible: false,
      technicalSheetId: null,
    };
  },
  components: {
    PortausLink,
    tableSkeleton,
    TechnicalSheetDrawer
  },
	methods: {
    showTechnicalSheet (id) {
      this.technicalSheetId = id;
      this.technicalSheetDrawerVisible = true;
    },
    closeTechnicalSheet () {
      this.technicalSheetId = null;
      this.technicalSheetDrawerVisible = false;
    },
    getVintage (item) {
      return ProductUtil.getVintageFromItem(item)
    },
    openPO(purchaseOrderId){
      var index='/inventories/'+this.inventoryId+'/purchase-orders/'+purchaseOrderId;
      this.$router.push(index);
    },
    moment(datetime){
			return  moment(datetime).format('l');
		},
    momentAdd(datetime, nbDays){
      return moment(datetime).add(nbDays,'days').format('l');
    },
	},
	computed: {
    showVintage(){
      return _.find(selectedProductItemsLeft, i => _.get(i, 'extraInfo.vintage') != null) != null;
    },
    showEndOfDelay () {
      return _.get(this.inventory, 'indAgency') === true || _.get(this.inventory, 'ind_agency') === true;
    },
    inventory () {
      return this.getInventory(this.inventoryId);
    },
    ...mapGetters('inventory', ['getInventory']),
    ...mapState('inventoryProducts', ['loadingSelectedProductItems']),
    ...mapGetters('inventoryProducts',['isNegative','isPositive','isIntermediary']),
	},
  mounted(){

  },
  created(){

  }
}
</script>
<style>
</style>
